module.exports = __webpack_public_path__ + "static/media/010.7da716f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/010.jpg
// module id = 307
// module chunks = 0